import { type ReactNode } from 'react';
import { useAuth } from '@/hooks/use-auth';
import { BonusHistoryModal } from './bonus-history-modal';
import {
  useRankingHistory,
  type PodiumSlot,
  type RankingWeek,
} from '../hooks/use-bonus-history';
import { RankingSlotCell } from './ranking-history-slot';

type Props = { open: boolean; onClose: () => void };

const TH =
  'pb-3 text-left text-[10px] font-medium uppercase tracking-wider text-text-tertiary/60';
const TD = 'py-3 align-middle';

function fmtDate(d: string): string {
  return d.slice(5, 10).replace('-', '/');
}

function findSlot(week: RankingWeek, pos: number): PodiumSlot | undefined {
  return week.podium.find((s) => s.position === pos);
}

function Row({ w, userId }: { w: RankingWeek; userId: string }): ReactNode {
  return (
    <tr className="border-t border-white/[0.06]">
      <td className={`${TD} pr-md text-[11px] tabular-nums text-text-tertiary`}>
        {fmtDate(w.week_start)}–{fmtDate(w.week_end)}
      </td>
      {[1, 2, 3].map((pos) => (
        <td key={pos} className={`${TD} pr-md`}>
          <RankingSlotCell slot={findSlot(w, pos)} userId={userId} />
        </td>
      ))}
    </tr>
  );
}

function Table({
  weeks,
  userId,
}: {
  weeks: RankingWeek[];
  userId: string;
}): ReactNode {
  return (
    <table className="w-full min-w-[32rem] text-left">
      <thead>
        <tr>
          <th className={TH}>Semana</th>
          <th className={TH}>1º</th>
          <th className={TH}>2º</th>
          <th className={TH}>3º</th>
        </tr>
      </thead>
      <tbody>
        {weeks.map((w) => (
          <Row key={w.week_start} w={w} userId={userId} />
        ))}
      </tbody>
    </table>
  );
}

export function RankingHistoryModal(p: Props): ReactNode {
  const { user } = useAuth();
  const { data, isLoading } = useRankingHistory(p.open);
  const weeks = data?.weeks ?? [];
  return (
    <BonusHistoryModal
      open={p.open}
      onClose={p.onClose}
      title="Histórico Top 3"
      loading={isLoading}
      empty={!isLoading && weeks.length === 0}
      emptyLabel="Sin podios todavía"
    >
      <Table weeks={weeks} userId={user?.id ?? ''} />
    </BonusHistoryModal>
  );
}
